<template>
  <div class="guidance1">
    <div class="navigation-bars">
      <div class="right-menu">
        <div class="user-avator right-menu-item">
          <img v-if="userInfo.avatar" class="user-header" :src="userInfo.avatar" />
          <img v-else src="@/assets/images/default.jpg" alt="">
        </div>
        <div class="name right-menu-item">{{ userInfo.nickname }}</div>
        <div class="setting right-menu-item">
          <el-dropdown trigger="click">
            <i class="el-icon-setting"></i>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item @click.native="goRouter">返回首页</el-dropdown-item>
              <el-dropdown-item @click.native="changePaw">修改密码</el-dropdown-item>-->
              <el-dropdown-item @click.native="logAot">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="guidance-content">
      <div class="sys-title">
        <h2 class="login-title">仪器智能系统-导入使用记录</h2>
      </div>
      <div class="cards-list">
        <el-upload
          class="upload-demo"
          drag
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          :multiple="false"
          :auto-upload="false"
          :action="uploadUrl">
          <i class="el-icon-upload"/>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" style="color: #f3f4f6;text-align: left;" slot="tip">上传运维记录文件，仅支持xlsx、xls格式文件</div>
        </el-upload>
        <div class="upload-result" v-show="isShow">
          <span :class="isSuccess?'success':'fail'">
            {{ resultMsg }}
          </span>
        </div>
        <div class="row-item" style="width: 97%; margin: 20px 10px 0 0; text-align: center;align-items: center;justify-content: center;">
          <div class="element-list jb-bg btn" @click="affirm">确认</div>
          <div class="element-list btn" @click="handleClear">清除</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FileUrl } from "@/api/depotApi";
import { updatePasw } from "@/api/userApi";
import myFiles from "./components/uploadLogo";
import axios from "@/util/request";
import {uploadLogo} from "@/api/systemApi";
export default {
  components: {
    myFiles,
  },
  data() {
    return {
      deptId: "", //单位id
      outerVisible: false,
      fileList:[],
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      staData: {},
      uploadUrl: "/ims/devOps/importUseInfo", //上传地址
      resultMsg: "",
      isShow: false,
      isSuccess: false
    };
  },
  mounted() {

  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    affirm() {
      if (this.fileList.length == 0) {
        this.$message.error("请选择需要上传的文件");
        return;
      }
      this.myupload(this.fileList[0].raw);
    },
    cancel() {
      this.$emit("cancel");
    },
    myupload(file) {
      let that = this;
      const form = new FormData();
      form.append("file", file);
      axios({
        url: that.uploadUrl,
        headers: { "Content-Type": "multipart/form-data" },
        method: "post",
        data: form,
      }).then((res) => {
        if (res.code === "200"){
          that.resultMsg = "上传成功";
          that.isSuccess = true;
        }else {
          that.isSuccess = false;
          that.resultMsg = res.msg;
        }
        that.isShow = true;
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传!");
      });
    },
    handleRemove(file, fileList) {
      this.$message.success("删除成功");
      // this.$set(this, "fileList", []);
      this.isShow = false;
    },
    handlePreview(file) {
      console.log(file);
    },
    submitForm(formName) {
      let that = this;
      if (this.ruleForm.pass.length < 6 && this.ruleForm.checkPass.length < 6) {
        this.$message.warning("密码长度不能小于6位");
        return;
      }
      if (this.ruleForm.pass != this.ruleForm.checkPass) {
        this.$message.warning("两次密码不一致！请重新输入");
        return;
      }
      updatePasw({ id: that.userInfo.userId, psw: that.ruleForm.pass }).then(
        (res) => {
          that.$message.success(res.msg || "密码修改成功！");
          that.resetForm();
          that.$store.dispatch("Logout").then(() => {
            setTimeout(() => {
              that.$router.replace({ path: "/login" });
            }, 1000);
          });
        }
      );
    },
    resetForm(formName) {
      this.ruleForm.pass = "";
      this.ruleForm.checkPass = "";
      this.outerVisible = false;
    },
    // 修改密码
    changePaw() {
      this.outerVisible = true;
    },
    // 退出登录
    logAot() {
      this.$store.dispatch("Logout").then(() => {
        setTimeout(() => {
          this.$message.success("退出成功");
          this.$router.replace({ path: "/login" });
        }, 1000);
      });
    },
    handleClear(){
      this.$set(this, "fileList", []);
      this.isShow = false;
    }
  },
};
</script>

<style lang="less" scoped>
.guidance1 {
  height: 100%;
  background-color: #10528c;
  background-image: url("~@/assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: relative;
  .navigation-bars {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    .left-menu {
      height: 100%;
      line-height: 60px;
      color: #ffffff;
      .left-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
        i {
          color: #ffffff;
          font-size: 24px;
        }
      }
    }

    .middle-menu {
      height: 60px;
      .middle-menu-item {
        display: inline-block;
        margin-right: 20px;
        font-size: 18px;
        line-height: 60px;
        .middle-menu-title {
          color: #ffffff;
        }
        .middle-menu-content {
          color: red;
        }
        @keyframes fade {
          from {
            opacity: 1;
          }
          50% {
            opacity: 0.4;
          }
          to {
            opacity: 1;
          }
        }

        @-webkit-keyframes fade {
          from {
            opacity: 1;
          }
          50% {
            opacity: 0.4;
          }
          to {
            opacity: 1;
          }
        }
        .middle-menu-content-jump {
          animation: fade 600ms infinite;
          -webkit-animation: fade 600ms infinite;
          cursor: pointer;
        }
      }
    }
    .right-menu {
      height: 60px;
      margin-right: 20px;
      line-height: 60px;
      color: #ffffff;
      .user-avator {
        img {
          width: 40px;
          height: 40px;
          margin-top: 7px;
          border-radius: 50%;
        }
      }
      .setting {
        i {
          color: #ffffff;
          font-size: 24px;
          cursor: pointer;
        }
      }
      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;
      }
    }
  }
  .guidance-content {
    height: calc(100% - 60px);
    /*padding: 0 5%;*/
    overflow: auto;
    text-align: center;
    .sys-title {
      width: 100%;
      text-align: center;
      .login-title {
        color: #7ec4ff;
        font-size: 42px;
        font-family: 宋体;
      }
    }
    .cards-list {
      flex-direction: column;
      width: 100%;
      margin: 0 auto;
      max-height: 540px;
      min-height: 480px;
      display: flex;
      justify-content: center;
      align-items: center;
      .upload-result{
        width: 312px!important;
        margin-top: 24px;
        background-color: #FFFFFF;
        padding: 24px;
        border-radius: 8px;
        text-align: left;
        .success{
          color: #4096ff!important;
        }
        .fail{
          color: #ff4d4f!important;
        }
      }
    }
    .footer {
      margin-top: 30px;
      margin-bottom: 10px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .useSMS {
        cursor: pointer;
        margin-top: 20px;
      }
    }
    // background: blue;
  }
  .popout {
    /deep/.el-form-item {
      border: 2px solid #0090f0;
      border-radius: 6px;
      height: 40px;
      line-height: 40px;
      margin: 20px 0;
      text-align: center;
      .el-form-item__label {
        background-image: linear-gradient(#0479b4, #02407e);
        text-align: center;
        color: #74c8fe;
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      color: #74c8fe;
      .element-list {
        width: 150px;
        cursor: pointer;
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin: 10px 0;
        margin-right: 10px;
        text-align: center;
      }
    }
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}

  .row-item {
    /*margin-left: 2%;*/
    display: flex;
  }
  .btn {
    width: 150px;
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 0 10px;
    text-align: center;
    cursor: pointer;
    color: #74c8fe;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
  .footer {
    display: flex;
    justify-content: center;
  }
  .content {
    width: 95%;
    .item-btn {
      width: 250px;
      height: 36px;
      line-height: 36px;
      margin: 0;
    }
    /deep/ .el-form-item__label {
      color: #74c8fe;
    }
    /deep/ .el-input__inner {
      border: 2px solid #0090f0;
      color: #74c8fe;
      background-color: transparent !important;
    }
  }

</style>




// WEBPACK FOOTER //
// src/views/devOps/inedx.vue